window.BEC = (function($, ns) {
	"use strict";

	/*
	 PubSub Events
	 'OPEN_MOBILE_MENU'
	 'CLOSE_MOBILE_MENU'
	 'OPEN_SEARCH'
	 'CLOSE_SEARCH'
	 */

	$(function() {

		/*  fix for viewport units in ios */
		window.viewportUnitsBuggyfill.init();

		/* dom fixes, no need to create an accordion widget */
		$(".accordion-numbered").each(function(i) {
			$(this).find(".accordion-section").each(function(i, el) {
				$(el).prepend("<span class='number'>" + (i + 1) + "</span>");
			});
		});

		/* global events, no need to create an fullscreen widget */
		$(".fullscreen__arrow").click(function() {
			$('html, body').animate({
				scrollTop: $(".fullscreen").height()
			}, 800);
		});

		/* Extend string : to First char Upper case */
		String.prototype.toFirstUpper = function() {
			return this.charAt(0).toUpperCase() + this.slice(1);
		}

		/* form value Helper */
		$.getFieldFormValue = function(form, fieldName) {
			if (!form || !fieldName)
				return null;

			var retValue = null;
			$(form).serializeArray().forEach(function(f) {
				if (f.name == fieldName)
					retValue = f.value;
			})

			return retValue;
		}

		/* widgets */
		$(".js-accordion").accordion({
			heightStyle: "content",
			icons: null,
			collapsible: true
		});
		$(".js-share").share();
		$(".js-carousel").carousel();
		$(".js-modal").modal();
		$(".js-tab").tabspanel();
		$(".scrollup").scrollup();
		$(".js-table").tableResponsive();
		$(".sticky-container").sticky();
		$(".sticky-cta").stickyCta();
		$(".map").googlemap();
		$(".breadcrumbs").breadcrumbs();
		$(".js-datalist").datalist();
		$(".menu").menu();
		$(".js-form-simulator").simulator();
		$(".js-form").formpanel();
		$(".js-ripple-btn").ripplefx();
		$(".js-list").articleList();
		$(".js-daterange").dateRange();
		$(".js-dropdown").dropdown();
		$(".js-dropdown-search").dropdownSearch();
		$(".js-radio").radiobutton();
		$(".js-dynamicForm").dynamicForm();
		$(".js-upload").uploadFile();
		$('.js-cookie-consent').cookieConsent();
		$('.js-mask-date-time').mask('00/00/0000 00:00');
		$('.js-mask-date').mask('00/00/0000');
		$('.js-mask-date-range').mask('00/00/0000 - 00/00/0000', {
			clearIfNotMatch: true
		});
		$('.sidebar').slideinSidebar();

	});

	return ns;

}(window.jQuery, window.BEC || {}));